import styled from "styled-components";

const PluginSection = styled.section.attrs({
  className: "w-100 mv3"
})``;

export default PluginSection;
